export default (selected, gui, entities) => {
	const userList = [];

	const userIsAdminOf = [];
	const contactEntities = {};

	entities.forEach(({entityId, entityAdmins, contacts}) => {
		if (entityAdmins?.some(({userId}) => userId === gui)) userIsAdminOf.push(entityId);
		contacts.forEach(({userId}) => {
			if (contactEntities?.[userId] !== undefined) contactEntities[userId] = [...contactEntities[userId], entityId];
			else contactEntities[userId] = [entityId];
		});
	});

	selected.forEach((userId) => {
		if(!contactEntities[userId]?.some((entityId) => userIsAdminOf.includes(entityId))) userList.push(userId);
	});

	return userList;
};
